import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {
  IconBadge,
  PaymentMethod,
} from '@core/services/room-details/room-details.service';
import { MbIconTextModule, MbIconModule } from '@am/moebius';


@Component({
    selector: 'am-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MbIconTextModule,
        MbIconModule,
    ],
})
export class PaymentMethodsComponent implements OnInit {
  @Input()
  badges: IconBadge<PaymentMethod>[] = [];

  constructor() {}

  ngOnInit(): void {}
}
